<ifc-horizontal-list [items]="listItems" class="container">
  <ng-template horizontalListCustomTemplate="statusValue">
    <div class="status-container">
      <ifp-account-status-icon-chip
        [status]="loan?.customerFacingStatus"
        [accountStatusIconChipModel]="accountStatusIconChipModel"
      ></ifp-account-status-icon-chip>
    </div>
  </ng-template>
  <ng-template horizontalListCustomTemplate="payoffNotes">
    <div class="payoff-notes-wrapper">
      <div class="payoff-notes">
        <span class="payoff-notes__title">Payoff notes</span>
        <span class="payoff-notes__value">{{ liquidityEvent?.payoffNotes }}</span>
      </div>
      <button
        mat-icon-button
        matTooltip="Edit payoff notes"
        class="mat-icon-button-sm"
        (click)="editPayoffNote(liquidityEvent)"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </ng-template>
</ifc-horizontal-list>
